import React, { useEffect } from 'react';
import { NoData } from 'src/@vymo/ui/blocks';
import SkeletonLoader from 'src/@vymo/ui/blocks/skelton';
import classnames from 'classnames';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { DEFAULT_NOTE_FETCH_LIMIT } from '../constants';
import { getThreadError, getThreadLoading, getThreadNotes } from '../selectors';
import { fetchNotes } from '../thunk';
import { NotesReplyViewProps } from '../types';
import MessageEditor from './editor';
// eslint-disable-next-line import/no-cycle
import Note from './note';
import styles from './index.module.scss';

function NotesReplyView({
  setShowReplyView,
  voId,
  id,
  childs,
  visibility,
}: NotesReplyViewProps) {
  const dispatch = useAppDispatch();
  const notes = useAppSelector((state) => getThreadNotes(state, id));

  const threadLoading = useAppSelector((state) => getThreadLoading(state, id));
  const threadError = useAppSelector((state) => getThreadError(state, id));

  useEffect(() => {
    if (childs > 0) {
      dispatch(
        fetchNotes({
          vo_id: voId,
          limit: DEFAULT_NOTE_FETCH_LIMIT,
          parent_key: id,
        }),
      );
    }
  }, [childs, dispatch, id, voId]);
  return (
    <div className={classnames(styles.noteView, styles.noteView__replyWrapper)}>
      {Boolean(threadError) && <NoData message={threadError} />}
      {Boolean(threadLoading) && (
        <SkeletonLoader rounded avtar lines={4} height={100} width="100%" />
      )}
      {notes.map((note) => (
        <Note
          note={note}
          isThreadNote
          classNames={styles.noteView__replyWrapper__note}
        />
      ))}
      <MessageEditor
        onCancel={setShowReplyView}
        isPrivate={visibility === 'private'}
        voId={voId}
        parentKey={id}
      />
    </div>
  );
}

export default NotesReplyView;
